import { useQuery } from "@apollo/client";
import { Breadcrumb, Button, Divider } from "pepsico-ds";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { loadSegment } from "../../graphql/queries/listSegments";
import { useToast } from "../../hooks/useToast";
import { paths } from "../../routes/paths";
import ToastNotification from "../common/toastNotification/ToastNotification";
import SegmentBasicsAccordion from "./platformSegments/SegmentBasicsAccordion";
import SegmentUsersList from "./platformSegments/SegmentUsersList";
import "./segmentation.scss";

export default function SegmentDetailsPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({});
  const { showToast, toast, closeToast } = useToast();

  const {
    data,
    refetch,
    loading: segmentLoading,
  } = useQuery(loadSegment, {
    variables: {
      id,
    },
    skip: !id,
  });

  useEffect(() => {
    if (data?.loadSegment) {
      setFormData(data?.loadSegment);
    }
  }, [data]);

  return (
    <div className="px-3 pt-3 platform-segments-container">
      <div className="platform-segment-detail-card">
        <div className="display-flex justify-content-space-between align-items-center mb-3">
          <div>
            <Breadcrumb
              breadcrumbs={[
                { href: "/", label: "Dashboard" },
                {
                  href: `/${paths.segmentation}/${paths.segment_list}/${paths.platform_segments}`,
                  label: "Segments",
                },
                {
                  href: `/${paths.segmentation}/${paths.segment_list}/${paths.platform_segments}/${paths.edit}/${id}`,
                  label: data?.loadSegment?.name || "Details",
                },
              ]}
            />
          </div>
        </div>

        <Divider orientation="horizontal" />

        <SegmentBasicsAccordion
          formData={formData}
          setFormData={setFormData}
          showToast={showToast}
          refetch={refetch}
          loading={segmentLoading}
        />

        <Divider orientation="horizontal" />
        <SegmentUsersList segmentId={id} showToast={showToast} />
        <div className="display-flex justify-content-end align-items-center mt-3">
          <Button
            variant="secondary"
            text="Close"
            size="medium"
            onClick={() => navigate(-1)}
          />
        </div>
      </div>
      <ToastNotification
        {...toast}
        handleClose={closeToast}
        primaryActionLabel={"Close"}
      />
    </div>
  );
}
